import { BASE_URL } from "../../data/BaseUrl";

export const fetchHygieneCategory = async (filters, TOKEN) => {
  // let url = `hygiene/category`;
  let url = `operation/task/status`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchHygieneCategory=> ", error);
    throw error;
  }
};

export const fetchHygieneTaskFrequency = async (filters, TOKEN) => {
  let url = ``;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchHygieneTaskFrequency=> ", error);
    throw error;
  }
};

export const fetchHygieneTasks = async (filters, TOKEN) => {
  // let url = `hygiene/task`;
  let url = `operation/task`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchHygieneTasks=> ", error);
    throw error;
  }
};

export const fetchExpenseCategories = async (filters, TOKEN) => {
  let url = `expense/category`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchExpenseCategories=> ", error);
    throw error;
  }
};

export const fetchProcessManager = async (filters, TOKEN) => {
  let url = `expense/process_manager`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchProcessManager=> ", error);
    throw error;
  }
};

export const fetchExpenseRequests = async (filters, TOKEN) => {
  let url = `expense/v2`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchExpenseRequests=> ", error);
    throw error;
  }
};

export const fetchFitnessCenters = async (filters, TOKEN) => {
  let url = `gym`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchFitnessCenters=> ", error);
    throw error;
  }
};

export const fetchGymBenefits = async (filters, TOKEN) => {
  let url = `gym`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();

    if (responseJson?.status && responseJson?.data?.length > 0) {
      const benefits = responseJson.data[0]?.benefits;

      return benefits;
    }

    return [];
  } catch (error) {
    console.error("fetchGymBenefits=> ", error);
    throw error;
  }
};

export const fetchAllBenefits = async (filters, TOKEN) => {
  let url = `benefits/v2`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();

    return responseJson;
  } catch (error) {
    console.error("fetchAllBenefits=> ", error);
    throw error;
  }
};

export const fetchTimeSheet = async (filters, TOKEN) => {
  let url = ``;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();

    return responseJson;
  } catch (error) {
    console.error("fetchTimeSheet=> ", error);
    throw error;
  }
};

export const fetchHygineTasksLogs = async (filters, TOKEN) => {
  let url = `operation/task/scheduled`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchHygineTasksLogs=> ", error);
    throw error;
  }
};

export const fetchHygineTasksLogsV2 = async (filters, TOKEN) => {
  let url = `operation/task/scheduled/v2`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchHygineTasksLogsV2=> ", error);
    throw error;
  }
};

export const fetchHygineTasksLogsStatus = async (filters, TOKEN) => {
  let url = `operation/task/scheduled/v2`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();

    return {
      status: responseJson?.status || false,
      pagination: responseJson?.pagination || [],
      data: responseJson?.data?.task_details || [],
    };
  } catch (error) {
    console.error("fetchHygineTasksLogsStatus=> ", error);
    throw error;
  }
};

export const fetchHygineTaskCategory = async (filters, TOKEN) => {
  let url = `operation/task/category`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchHygineTaskCategory=> ", error);
    throw error;
  }
};

export const fetchHygineRequests = async (filters, TOKEN) => {
  let url = `operation/breakdown/request`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchHygineRequests=> ", error);
    throw error;
  }
};

export const fetchHygineAddonRequests = async (filters, TOKEN) => {
  let url = `operation/breakdown/request/addon`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchHygineAddonRequests=> ", error);
    throw error;
  }
};

export const fetchHygineGymwise = async (filters, TOKEN) => {
  let url = `operation/task/scheduled/gymwise`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchHygineGymwise=> ", error);
    throw error;
  }
};

export const fetchHygineTasksApproval = async (filters, TOKEN) => {
  let url = `operation/breakdown/request`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchHygineTasksApproval=> ", error);
    throw error;
  }
};

export const fetchHygineStats = async (filters, TOKEN) => {
  let url = `operation/task/overview/stats`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchHygineStats=> ", error);
    throw error;
  }
};

export const fetchHygineFrequencies = async (filters, TOKEN) => {
  let url = `operation/task/overview`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchHygineFrequencies=> ", error);
    throw error;
  }
};

export const fetchHygineFrequenciesTasks = async (filters, TOKEN) => {
  let url = `operation/task/overview/details`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchHygineFrequenciesTasks=> ", error);
    throw error;
  }
};

export const fetchGymFeedbacks = async (filters, TOKEN) => {
  let url = `feedback/gym-feedback`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchGymFeedbacks=> ", error);
    throw error;
  }
};

export const fetchBcaReport = async (filters, TOKEN) => {
  let url = `ptTrial/bca_report`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchBcaReport=> ", error);
    throw error;
  }
};

export const fetchHygieneCommandCenterStats = async (filters, TOKEN) => {
  let url = `operation/command-center/stats`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchHygieneCommandCenterStats=> ", error);
    throw error;
  }
};

export const fetchHygieneCommandCenterMatrix = async (filters, TOKEN) => {
  let url = `operation/command-center/matrix-v2`;

  const filteredParams = Object.entries(filters)
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchHygieneCommandCenterMatrix=> ", error);
    throw error;
  }
};

export const fetchHygieneCommandCenterGymCompliance = async (filters, TOKEN) => {
  let url = `operation/command-center/gym-compliance`;

  const filteredParams = Object.entries(filters)
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchHygieneCommandCenterGymCompliance=> ", error);
    throw error;
  }
};

export const fetchTaskDetails = async (filters, TOKEN) => {
  let url = `operation/task/details`;

  const filteredParams = Object.entries(filters)
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchTaskDetails=> ", error);
    throw error;
  }
};
